import { render, staticRenderFns } from "./process-deploy.vue?vue&type=template&id=472f7ce5&"
import script from "./process-deploy.vue?vue&type=script&lang=js&"
export * from "./process-deploy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports